import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { messages as m } from '../../constants';
import * as D from '../../deps';

export class PodcastCategoryGridItem extends React.Component {
  static propTypes = {
    pandoraId: PropTypes.string.isRequired,
    categoryName: PropTypes.string,
    categoryUrl: PropTypes.string,
    categoryId: PropTypes.string,
    artUrl: PropTypes.string,
    totalPodcasts: PropTypes.number,
    getDetails: PropTypes.func.isRequired,
    getBrowseDirectory: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (this.props.pandoraId) {
      if (!this.props.categoryId) {
        // this would be called when annotations were not found for the program / episode
        this.props.getDetails(this.props.pandoraId);
      } else if (this.props.categoryId && !this.props.categoryUrl) {
        // this would be called when program / episode annotations were found but lacked url needed to link to browse
        this.props.getBrowseDirectory({ directoryId: this.props.categoryId });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.categoryId !== prevProps.categoryId &&
      this.props.categoryId &&
      !this.props.categoryUrl
    ) {
      this.props.getBrowseDirectory({ directoryId: this.props.categoryId });
    }
  }

  render() {
    const gridItemProps = {
      isPlaceholder: !this.props.categoryUrl,
      imgUrl: this.props.artUrl,
      mainText: this.props.categoryName,
      mainTextUrl: this.props.categoryUrl,
      secondText: (
        <FormattedMessage
          {...D.Constants.Podcasts.messages.podcastCount}
          values={{ count: this.props.totalPodcasts }}
        />
      ),
      hoverText: <FormattedMessage {...m.viewCategory} />,
      itemOnclickUrl: this.props.categoryUrl,
    };
    return <D.GridItem {...gridItemProps} />;
  }
}

export function mapStateToProps(state, ownProps) {
  const { pandoraId } = ownProps;
  const details = D.getDetails(state, pandoraId);
  let browseDirectory;
  let categoryId;
  let categoryName;
  let categoryUrl;
  let artUrl;
  let totalPodcasts;

  // catalog data
  if (!details.isEmpty()) {
    if (details.has('programCategories')) {
      categoryId = details.get('programCategories').first();
    } else if (details.has('categories')) {
      categoryId = details.get('categories').first();
    }
    const categoryAnnotations = D.getAnnotationsById(state, categoryId);
    if (categoryAnnotations) {
      categoryName = categoryAnnotations.get('name');
      artUrl = D.getArt(categoryAnnotations, 500, state);
    }
  }

  // browse data
  if (categoryId) {
    // categoryId is used to get browse directory
    browseDirectory = D.getInDomain('discovery.selectors.getBrowseDeepLevelDirectoryByRequestId')(
      state,
      categoryId,
    );
    if (browseDirectory) {
      totalPodcasts = browseDirectory.totalItems;
      categoryUrl = browseDirectory.webUrl;
    }
  }

  return {
    pandoraId,
    categoryName,
    categoryUrl,
    categoryId,
    artUrl,
    totalPodcasts,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDetails: D.getInDomain('catalog.actions.getDetails'),
      getBrowseDirectory: D.getInDomain('discovery.actions.getBrowseDirectory'),
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PodcastCategoryGridItem);
